import { Game } from "./components/Game";
import { HowToPlay } from "./components/HowToPlay";
import { PuzzleStatus } from "./components/PuzzleStatus";
import { ThemeToggle } from "./components/ThemeToggle";
import { MastheadParticles } from "./effects/MastheadParticles";
import { PUZZLES } from "./game/puzzles";
import { fireCelebration } from "./game/state";

export function App() {
  // Click-to-fire-celebration is a pre-deploy testing affordance only —
  // production renders the masthead as plain art so a stray tap during
  // play can't trigger the win sequence.
  const mastheadStage = import.meta.env.DEV ? (
    <button
      type="button"
      class="app__masthead-stage"
      onClick={() => fireCelebration()}
      aria-label="Play celebration animation"
      tabIndex={-1}
    >
      <img
        class="app__masthead"
        src="/masthead.jpg"
        width="1600"
        height="640"
        alt="PalinDragon"
      />
      <MastheadParticles />
    </button>
  ) : (
    <div class="app__masthead-stage app__masthead-stage--static">
      <img
        class="app__masthead"
        src="/masthead.jpg"
        width="1600"
        height="640"
        alt="PalinDragon"
      />
      <MastheadParticles />
    </div>
  );
  return (
    <div class="app">
      <header class="app__header">
        <div class="app__banner" role="note">
          <div class="app__banner__line">
            CONFIDENTIAL - INVITATION ONLY - FEEDBACK:{" "}
            <a href="mailto:wolf@lockedlab.com?subject=PalinDragon%20Feedback">
              WOLF@LOCKEDLAB.COM
            </a>
          </div>
          <div class="app__banner__line app__banner__line--gold">
            PRE-RELEASE: {PUZZLES.length} CLASSICS RANDOMLY CHOSEN AT RELOAD
          </div>
        </div>
        <div class="app__toolbar">
          <HowToPlay />
          <PuzzleStatus />
          <ThemeToggle />
        </div>
        {mastheadStage}
        <h1 class="app__title sr-only">PalinDragon</h1>
      </header>
      <main class="app__main">
        <Game />
      </main>
      <footer class="app__footer">
        PalinDragon™ — The daily palindromic-sentence word game by{" "}
        <a
          href="https://lockedlab.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Locked Lab
        </a>
      </footer>
    </div>
  );
}
